import { cva } from '@/styled-system/css';

export const pageBreadcrumbRecipe = cva({
  base: {
    boxSizing: 'content-box',
    marginInline: 'auto',
    marginBlockStart: {
      base: 'Page.Breadcrumb.margin.top.mobile',
      md: 'Page.Breadcrumb.margin.top.tablet',
      xl: 'Page.Breadcrumb.margin.top.desktop',
    },
    marginBlockEnd: 'zero',
    paddingInline: {
      base: 'Page.padding.horz.mobile',
      md: 'Page.padding.horz.tablet',
      xl: 'Page.padding.horz.desktop',
    },
  },
  variants: {
    fluid: {
      true: {
        maxWidth: 'none',
      },
      false: {
        maxWidth: '1280px',
      },
    },
  },
});
